import { tenantRoutes } from './modules/routing.js'
import { platformRoutes, resolvePlatformMenuPath } from './modules/platformRouting.js'
import { PORTAL_PLATFORM, PORTAL_TENANT, getPortalForCurrentRoute } from '@/utils/authSession.js'

export { tenantRoutes, platformRoutes, resolvePlatformMenuPath }

/** 当前门户对应的侧边栏路由配置 */
export function getMenuRoutesForPortal(portal = getPortalForCurrentRoute()) {
  return portal === PORTAL_PLATFORM ? platformRoutes : tenantRoutes
}

export function resolveMenuItemPath(item, portal = getPortalForCurrentRoute()) {
  if (portal === PORTAL_PLATFORM) {
    return resolvePlatformMenuPath(item)
  }
  return item.path
}

export function isPlatformPortal(portal = getPortalForCurrentRoute()) {
  return portal === PORTAL_PLATFORM
}

export { PORTAL_TENANT, PORTAL_PLATFORM }
